import React, { useState } from "react";
import "./ProduktKontakt.css";
import { database } from "../firebaseConfig";
import { ref, push } from "firebase/database";
import { storage } from "../firebaseConfig";
import { ref as storageRef, uploadBytes, getDownloadURL } from "firebase/storage";
import { ToastContainer } from "../Components/Toast";
import { useAntiSpam, AntiSpamHoneypot, AntiSpamModal } from "../Components/AntiSpam";

function KontaktForm({ submitForm, ProduktName }) {
  const [Submitted, setSubmitted] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [toasts, setToasts] = useState([]);
  const antiSpam = useAntiSpam();

  // Toast-Funktion
  const addToast = (message, type = "success", duration = 5000) => {
    const id = Date.now();
    setToasts((prevToasts) => [...prevToasts, { id, message, type, duration }]);
  };

  const removeToast = (id) => {
    setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
  };

  // Validierungsfunktionen
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePhone = (phone) => {
    // Erlaubt Ziffern, Leerzeichen, +, -, und Klammern ()
    const phoneRegex = /^[\d\s+()\-]{6,20}$/;
    return phone === "" || phoneRegex.test(phone); // Optional, daher leer erlaubt
  };

  const validateForm = (formData) => {
    const errors = {};
    
    // E-Mail validieren
    const email = formData.get("email");
    if (!validateEmail(email)) {
      errors.email = "Bitte geben Sie eine gültige E-Mail-Adresse ein";
    }
    
    // Telefon validieren (wenn vorhanden)
    const phone = formData.get("telefon");
    if (phone && !validatePhone(phone)) {
      errors.telefon = "Bitte geben Sie eine gültige Telefonnummer ein";
    }
    
    return errors;
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        addToast("Die Datei ist zu groß. Bitte wählen Sie eine Datei mit maximal 5 MB.", "error");
        return;
      }
      if (file.type === "image/jpeg" || file.type === "image/png") {
        setSelectedImage(file);
        setImagePreview(URL.createObjectURL(file));
      } else {
        addToast("Bitte nur JPG oder PNG Dateien auswählen.", "error");
      }
    }
  };

  const sendRequest = (e) => {
    e.preventDefault();

    const form = e.target;
    const formData = new FormData(form);

    // Formular validieren
    const errors = validateForm(formData);
    setFormErrors(errors);

    // Wenn es Fehler gibt, Absenden abbrechen
    if (Object.keys(errors).length > 0) {
      return;
    }

    // Öffnet das Sicherheits-Modal. Nach Bestätigung wird doSubmit ausgeführt.
    antiSpam.requestSubmit(() => {
      doSubmit(form, formData);
    });
  };

  const doSubmit = async (form, formData) => {
    setIsSubmitting(true); // Spinner aktivieren

    const data = {
      name: formData.get("name"),
      email: formData.get("email"),
      telefon: formData.get("telefon"),
      adresse: formData.get("adresse"),
      plz: formData.get("plz"),
      message: formData.get("message"),
      produkt: formData.get("produkt"),
      stueckzahl: formData.get("stueckzahl"),
      timestamp: new Date().toISOString(),
    };

    let imageUrl = null;
    if (selectedImage) {
      const imageStorageRef = storageRef(
        storage,
        `anfragen-bilder/${selectedImage.name}`
      );
      try {
        const snapshot = await uploadBytes(imageStorageRef, selectedImage);
        imageUrl = await getDownloadURL(snapshot.ref);
        data.imageUrl = imageUrl;
      } catch (error) {
        console.error("Fehler beim Hochladen des Bildes:", error);
        addToast("Es gab einen Fehler beim Hochladen des Bildes. Bitte versuchen Sie es erneut.", "error");
        setIsSubmitting(false); // Spinner deaktivieren
        return;
      }
    }

    const dbRef = ref(database, "/Anfragen");
    push(dbRef, data)
      .then(() => {
        form.reset();
        setSelectedImage(null);
        setImagePreview(null);
        setFormErrors({});
        antiSpam.reset();
        setSubmitted(true);
        addToast("Ihre Anfrage wurde erfolgreich gesendet!");
        submitForm();
      })
      .catch((error) => {
        console.error("Fehler beim Speichern der Anfrage:", error);
        addToast("Es gab einen Fehler beim Senden der Anfrage. Bitte versuchen Sie es später erneut.", "error");
      })
      .finally(() => {
        setIsSubmitting(false); // Spinner deaktivieren
      });
  };

  const removeImage = () => {
    setSelectedImage(null);
    setImagePreview(null);
  };

  return (
    <div className="formular">
      <ToastContainer toasts={toasts} removeToast={removeToast} />
      
      <form onSubmit={sendRequest} id="contact-form" name="contact-form">
        <input
          className="input"
          placeholder="Vor & Nachname*"
          name="name"
          type="text"
          required
        />
        <div className="input-container">
          <input
            className={`input ${formErrors.email ? "input-error" : ""}`}
            placeholder="E-Mail-Adresse*"
            type="email"
            name="email"
            required
          />
          {formErrors.email && <div className="error-message">{formErrors.email}</div>}
        </div>
        <div className="input-container">
          <input
            className={`input ${formErrors.telefon ? "input-error" : ""}`}
            placeholder="Telefonnummer"
            name="telefon"
            type="text"
          />
          {formErrors.telefon && <div className="error-message">{formErrors.telefon}</div>}
        </div>
        
        <div className="input-container">
          <input
            className="input"
            placeholder="Adresse"
            name="adresse"
            type="text"
          />
        </div>
        
        <div className="input-container">
          <input
            className="input"
            placeholder="PLZ & Ort"
            name="plz"
            type="text"
          />
        </div>

        <select className="input3" name="stueckzahl" required>
          <option value="1-10">1-10 Stück</option>
          <option value="11-100">11-100 Stück</option>
          <option value="101-200">101-200 Stück</option>
          <option value="201-500">201-500 Stück</option>
          <option value="500+">500+ Stück</option>
        </select>

        <textarea
          className="input5"
          placeholder="Wie können wir Ihnen weiterhelfen?"
          type="text"
          name="message"
        />
        <select
          className="input_6"
          name="produkt"
          required
          defaultValue={ProduktName}
        >
          <option value={ProduktName}>{ProduktName}</option>
        </select>

        <div
          className="image-upload-container"
          onClick={() => document.getElementById("image").click()}
        >
          {imagePreview ? (
            <span>
              <img
                src={imagePreview}
                alt="Bildvorschau"
                className="image-preview"
              />
              <button
                type="button"
                className="remove-image-button"
                onClick={(e) => {
                  e.stopPropagation();
                  removeImage();
                }}
              >
                ✕
              </button>
            </span>
          ) : (
            <div className="image-upload-container-wrapper">
              <img src="./img/img-upload.svg" alt="" />
              <div>
                <span>Bild hochladen (.jpeg / .png)</span>
                <p style={{fontSize: "12px", marginTop: "5px", color: "#666"}}>Maximale Dateigröße: 5 MB</p>
              </div>
            </div>
          )}
        </div>
        <input
          type="file"
          id="image"
          className="hidden-image-input"
          accept="image/jpeg, image/png"
          onChange={handleImageChange}
        />

        <AntiSpamHoneypot {...antiSpam} />

        <div className="checkbox_container">
          <input type="checkbox" id="kontakt" name="kontakt" required />
          <label htmlFor="kontakt">
            Ich akzeptiere die Datenschutzbestimmungen
          </label>
        </div>
        <button type="submit" className="submit-button" disabled={isSubmitting}>
          {isSubmitting ? (
            <span className="spinner"></span> // Spinner anzeigen
          ) : (
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            <p>Absenden</p>
            <img style={{filter: 'invert(1)', width: '18px', marginLeft: '5px'}} src="./img/right.svg" alt="" />
            </div>
          )}
        </button>
      </form>

      <AntiSpamModal {...antiSpam} />
    </div>
  );
}

export default KontaktForm;
